import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function Footer() {
  return (
    <Navbar  expand="lg sm xs md" className='nav-bar' variant="dark"  >
      <Container>
        <Navbar.Brand href="/"></Navbar.Brand>
       
          <Nav className="me-auto">
          <Nav.Link href="/">Home</Nav.Link>
          <Nav.Link href="/services">Services</Nav.Link>
            <Nav.Link href="/career">Career</Nav.Link>
            <Nav.Link href="#pricing">Contact Us</Nav.Link>
       
          </Nav>
          <Nav>
            <Nav.Link href="#deets">&copy; 2023</Nav.Link>
         
          </Nav>
       
      </Container>
    </Navbar>
  );
}

export default Footer;